import { AddDictionarySvg, PredictDictionaryIcon } from '../../../../assets';
import {
    CreateFeatureMenuItem,
    FeatureItems,
} from '../../../../components/create-feature-dialog/create-feature-dialog-helper';
import { DICTIONARY_PATHS } from '../../../../constants/dictionary-paths';
import { JOB_MANAGER_FEATURE_ITEMS } from '../../../job-manager/job-manager-helper';

export const DICTIONARY_FEATURE_ITEMS: FeatureItems = {
    DICTIONARY: {
        title: 'New From Scratch',
        subtitle: 'Create a new dictionary from scratch.',
        icon: AddDictionarySvg,
        navigationPath: DICTIONARY_PATHS.CREATE_NEW_DICTIONARY,
    },
    PREDICT_DICTIONARY: {
        title: 'Predict Dictionary',
        subtitle: 'Derive a dictionary from a sample data file.',
        icon: PredictDictionaryIcon,
        navigationPath: DICTIONARY_PATHS.PREDICT_DICTIONARY,
    },
};

export const dictionaryMenuItems: CreateFeatureMenuItem[] = [
    DICTIONARY_FEATURE_ITEMS.DICTIONARY,
    JOB_MANAGER_FEATURE_ITEMS.DBSCHEMA,
    JOB_MANAGER_FEATURE_ITEMS.DATA_DICTIONARY,
    DICTIONARY_FEATURE_ITEMS.PREDICT_DICTIONARY,
];
